<div class="field">
    <div class="section">

        <div class="header">
            <h3 class="left"><strong>{{fieldTitle(field).toUpperCase()}}</strong></h3>
            <div class="right">
                <button mat-icon-button color="red" aria-label="Remove Field" (click)="deleteField()">
                    <mat-icon>delete</mat-icon>
                </button>
            </div>
        </div>

        <div class="body">

            <!-- BASIC -->
            <div>
    
                <div class="header">
                    <h3 class="left">Basic</h3>
                </div>
                
                <div style="display: flex; flex-direction: row; column-gap: 10px;">

                    <mat-form-field appearance="fill" style="flex-grow: 1;">
                        <mat-label>Field Type</mat-label>
                        <mat-select [(value)]="field._type">
                            <mat-option *ngFor="let type of profileFieldTypes" [value]="type.type">
                            {{type.type}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
            
                    <mat-form-field appearance="fill" style="flex-grow: 1;">
                        <mat-label>ID</mat-label>
                        <input matInput type="text" [(ngModel)]="field.id" #idInput />
                    </mat-form-field>
            
                    <mat-form-field appearance="fill" style="flex-grow: 1;">
                        <mat-label>Label</mat-label>
                        <input matInput type="text" [(ngModel)]="field.name" />
                    </mat-form-field>
            
                    <mat-form-field appearance="fill" style="flex-grow: 1;">
                        <mat-label>Order</mat-label>
                        <input matInput type="number" [(ngModel)]="field.order" />
                    </mat-form-field>
                </div>
            
            </div>

            <div>
                <div style="display: flex; flex-direction: row; column-gap: 10px;">
                    <mat-form-field appearance="fill" style="flex-grow: 1;">
                        <mat-label>Description</mat-label>
                        <input matInput type="text" [(ngModel)]="field.description" />
                    </mat-form-field>
                </div>
            </div>
            
            <!-- OPTIONS AND REF -->
            <div class="section" style="margin-bottom: 10px;">

                <div class="header" *ngIf="showOptionsTitle(field)">
                    <h3 class="left">{{optionsLabel(field)}}</h3>
                    <div class="right" style="display: flex; flex-direction: row; column-gap: 10px;">
                        <mat-button-toggle-group name="fontStyle" aria-label="Font Style" (change)="fieldOptionsChange(field, $event.value)">
                            <mat-button-toggle value="none" [checked]="fieldOptionChecked(field, 'none')">None</mat-button-toggle>
                            <mat-button-toggle value="options" [checked]="fieldOptionChecked(field, 'options')">Options</mat-button-toggle>
                            <mat-button-toggle value="ref" [checked]="fieldOptionChecked(field, 'ref')">Reference</mat-button-toggle>
                        </mat-button-toggle-group>
                        <button color="lightGreen" mat-flat-button color="accent" class="right"  *ngIf="fieldOptionChecked(field, 'options')" (click)="profileFieldOptionAdd()">Add Option</button>
                    </div>
                </div>

                <!-- REF -->
                <div *ngIf="fieldOptionChecked(field, 'ref')">
                    <mat-form-field appearance="fill">
                        <mat-label>Entity</mat-label>
                        <mat-select [(value)]="field.ref.type">
                            <mat-option *ngFor="let type of referenceTypes" [value]="type.value">
                            {{type.label}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="fill">
                        <mat-label>Label</mat-label>
                        <mat-select [(value)]="field.ref.label">
                            <mat-option *ngFor="let lbl of labelsForReference(field)" [value]="lbl">
                            {{lbl}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            
                <!-- OPTIONS -->
                <div *ngIf="fieldOptionChecked(field, 'options')">
                    <div style="display: flex; flex-direction: row;" *ngFor="let opt of field.options; index as o">
                        <mat-form-field appearance="fill">
                            <mat-label>Label</mat-label>
                            <input matInput type="text" [(ngModel)]="opt.label">
                        </mat-form-field>
                        <mat-form-field appearance="fill">
                            <mat-label>Value</mat-label>
                            <input matInput type="text" [(ngModel)]="opt.value">
                        </mat-form-field>
                        <div style="flex: 1">
                            <button mat-icon-button color="red" aria-label="Remove Field" (click)="profileFieldOptionRemove(index, o)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            
            </div>
            
            <!-- USAGE -->
            <div class="section" style="margin-bottom: 10px;">
                <div class="header">
                    <h3 class="left">Usage</h3>
                </div>
                <div style="display: flex; flex-direction: row; column-gap: 10px; padding-left: 5px;">
            
                    <mat-checkbox
                        [(ngModel)]="field.customers"
                        color="lightGreen"
                        style="margin-right: 20px;">
                        Customer List
                    </mat-checkbox>
            
                    <mat-checkbox
                        [(ngModel)]="field.customer_detail"
                        color="lightGreen"
                        style="margin-right: 20px;">
                        Customer Detail
                    </mat-checkbox>
            
                    <mat-checkbox
                        [(ngModel)]="field.signal_condition"
                        color="lightGreen">
                        Signal Condition
                    </mat-checkbox>
            
                    <mat-checkbox
                        [(ngModel)]="field.assistant"
                        color="lightGreen">
                        Assistants
                    </mat-checkbox>
            
                </div>
            </div>
        
            <!-- OBJECT or OBJECT[] -->
            <div class="section" *ngIf="allowFields()">
                <div class="header" style="margin-bottom: 10px;">
                    <h3 class="left">Fields</h3>
                    <div class="right" style="display: flex; flex-direction: row; column-gap: 10px;">
                        <button color="lightGreen" mat-flat-button color="accent" class="right" (click)="addField()">Add Field</button>
                    </div>
                </div>
                <div class="fields">
                    <app-catalog-field class="field-container" *ngFor="let f of field.fields; index as i" [fields]="field.fields" [field]="f" [index]="i" [account]="this.account"></app-catalog-field>
                </div>
            </div>
        </div>
    
        
</div>
